<template>
  <div class="mmain" v-title data-title="北京天蔚中医药发展促进中心-关于我们">
    <div class="mNav">
      <div @click="first" style="border-right: 1px solid #ccc" class="title">
        <h3>{{ nav[firstCurrentIndex].title }}</h3>
        <i class="el-icon-arrow-down"></i>
      </div>
      <div @click="second" class="title">
        <h3>
          {{
            nav[firstCurrentIndex].children
              ? nav[firstCurrentIndex].children[secondCurrentIndex].title
              : "关于我们"
          }}
        </h3>
        <i
          v-show="nav[firstCurrentIndex].children"
          class="el-icon-arrow-down"
        ></i>
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <el-drawer
      size="50%"
      class="drawer"
      title="我是标题"
      direction="btt"
      :visible.sync="firstdrawer"
      :with-header="false"
    >
      <ul>
        <li
          :style="index == firstCurrentIndex ? 'color:#fe7333;' : ''"
          @click="toLink(item, index)"
          v-for="(item, index) in nav"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
    </el-drawer>
    <el-drawer
      size="50%"
      class="drawer"
      title="我是标题"
      direction="btt"
      :visible.sync="seconddrawer"
      :with-header="false"
    >
      <ul>
        <li
          :style="index == secondCurrentIndex ? 'color:#fe7333;' : ''"
          @click="toSecondLink(item, index)"
          v-for="(item, index) in nav[firstCurrentIndex].children"
          :key="index"
        >
          {{ item.title }}
        </li>
      </ul>
    </el-drawer>
  </div>
</template>
<script>
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        {
          title: "公司信息",
          url: "mgsxx",
          children: [
            { title: "机构简介", url: "mjgjj" },
            { title: "章程", url: "mzc" },
            { title: "理事会", url: "mlsh" },
            { title: "法人登记证", url: "mfrdjz" },
            { title: "理事长简介", url: "mlszjj" },
            { title: "专家顾问", url: "mzjgw" },
          ],
        },
        { title: "组织结构", url: "mzzjg" },
        { title: "成长历程", url: "mczlc" },
        { title: "联系我们", url: "mlxwm" },
      ],
      // snav: [
      //   { title: "机构简介", url: "mjgjj" },
      //   { title: "章程", url: "mzc" },
      //   { title: "理事会", url: "mlsh" },
      //   { title: "法人登记证", url: "mfrdjz" },
      //   { title: "理事长简介", url: "mlszjj" },
      //   { title: "专家顾问", url: "mzjgw" },
      // ],
      firstdrawer: false,
      seconddrawer: false,
      firstCurrentIndex: 0,
      secondCurrentIndex: 0,
    }
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getpCurrent", "mconntect")
    })
  },
  methods: {
    // 关于我们第一栏
    first() {
      this.firstdrawer = true
    },
    // 关于我们第二栏
    second() {
      if (this.nav[this.firstCurrentIndex].children) {
        this.seconddrawer = true
      }
    },
    // 第一栏切换
    toLink(item, index) {
      this.firstCurrentIndex = index
      this.$router.push({ name: item.url })
      this.firstdrawer = false
    },
    // 第二栏切换
    toSecondLink(item, index) {
      this.secondCurrentIndex = index
      this.$router.push({ name: item.url })
      this.seconddrawer = false
    },
  },
  components: {},
}
</script>

<style lang="less" scoped>
.mmain {
  width: 100%;
  margin-top: 150px;
  .mNav {
    width: calc(100vw - 60px);
    margin: 0 auto;
    display: flex;
    border-radius: 10px;
    background-color: #fff;
    border: 1px solid #ccc;
    .title {
      display: flex;
      justify-content: flex-end;
      font-size: 30px;
      color: #333;
      width: 50%;
      height: 60px;
      align-items: center;
      h3 {
        flex: 1;
        text-align: center;
      }
      i {
        margin-right: 10px;
      }
    }
  }
  .drawer {
    ul {
      li {
        margin-top: 50px;
        font-size: 30px;
        margin-left: 60px;
      }
    }
  }
  .content {
    width: 100%;
  }
}
</style>